export default __webpack_public_path__ + "static/media/logo-mobile.7611d1bb.svg";